class Modal {
    constructor() {
        this.playButtons = $('.play');

        if (this.playButtons.length === 0) {
            return;
        }

        this._setupEvents();
    }

    _appendModal(modalTemplate) {
        document.body.insertAdjacentHTML('beforeend', modalTemplate);
        this._setupCloseEvent();
        this._centerModal();
    }

    _centerModal() {
        const modal = document.getElementById('modal');
        const modalHeight = modal.offsetHeight;
        const windowHeight = window.innerHeight || 0;
        const browserHeight = Math.max(document.documentElement.clientHeight, windowHeight);
        let modalTop = 10;
        const pagePosition =  document.documentElement.scrollTop || document.body.scrollTop;

        if (modalHeight < browserHeight) {
            modalTop = browserHeight / 2 - modalHeight / 2;
        }

        modal.style.top = pagePosition + modalTop + 'px';
    }

    _closeModal(e) {
        const closeButton = document.getElementById('modal-close');
        const overlay = document.getElementById('modal-overlay');
        const modal = document.getElementById('modal');

        // If the escape key is pressed and no modal is open, return
        if (!overlay || !modal) {
            return;
        }

        overlay.parentNode.removeChild(overlay);
        modal.parentNode.removeChild(modal);
    }

    _updateModalHtml(videoUrl) {
        if (!videoUrl) {
            return;
        }

        const modalTemplate = document.getElementById('modal-template').innerHTML;
        const modalHTML = modalTemplate.replace("[[video-url]]", videoUrl);

        this._appendModal(modalHTML);
    }

    _setupCloseEvent() {
        const closeButton = document.getElementById('modal-close');

        closeButton.addEventListener('click', e => {
            e.preventDefault();
            this._closeModal();
        });
    }

    _setupEvents() {
        this.playButtons.on('click', e => {
            e.stopPropagation()
            const $btn = $(e.target)
            const videoProvider = $btn.data('video-provider')
            const videoId = $btn.data('video-id')
            let videoUrl = ''

            if (videoProvider == 'vidyard') {
                videoUrl = 'https://play.vidyard.com/' + videoId
            } else {
                videoUrl = 'https://www.youtube.com/embed/' + videoId + '?rel=0&amp;showinfo=0&autoplay=1'
            }

            this._updateModalHtml(videoUrl);
        })

        document.addEventListener('keyup', e => {
            const isEscape = e.keyCode === 27;

            if (isEscape) {
                this._closeModal();
            }
        });
    }
}

export default Modal;
